import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-survey-card',
  templateUrl: './patient-survey-card.component.html',
  styleUrls: ['./patient-survey-card.component.css']
})
export class PatientSurveyCardComponent implements OnInit {

  constructor() { }

  @Input() caseList;
  @Input() panel;
  @Output() link = new EventEmitter();

  ngOnInit() {
  }

  navigate(link) {
    this.link.emit(link);
  }

}
